// Master Table: Unit Types with Labour Hour Ranges
export const UNIT_TYPES = {
  '1b_1b': {
    label: '1B / 1B (~700 sqft)',
    sqft: 700,
    labourHoursMin: 4.0,
    labourHoursMax: 5.0
  },
  '2b_1b': {
    label: '2B / 1B (~900 sqft)',
    sqft: 900,
    labourHoursMin: 5.0,
    labourHoursMax: 6.0
  },
  '2b_2b': {
    label: '2B / 2B (~1000 sqft)',
    sqft: 1000,
    labourHoursMin: 6.0,
    labourHoursMax: 7.0
  },
  'large_3b_2b': {
    label: 'Large 3B / 2B (~1400 sqft)',
    sqft: 1400,
    labourHoursMin: 8.0,
    labourHoursMax: 9.0
  },
  'townhome_3level': {
    label: 'Townhome 3-Level (~1800 sqft)',
    sqft: 1800,
    labourHoursMin: 10.0,
    labourHoursMax: 12.0
  }
};

// On-Site Time Table (hours/unit by crew size)
export const ONSITE_TIME = {
  '1b_1b': {
    crew2: [2.0, 2.5],
    crew3: [1.3, 1.7],
    crew4: [1.0, 1.25]
  },
  '2b_1b': {
    crew2: [2.5, 3.0],
    crew3: [1.7, 2.0],
    crew4: [1.25, 1.5]
  },
  '2b_2b': {
    crew2: [3.0, 3.5],
    crew3: [2.0, 2.3],
    crew4: [1.5, 1.75]
  },
  'large_3b_2b': {
    crew2: [4.0, 4.5],
    crew3: [2.7, 3.0],
    crew4: [2.0, 2.25]
  },
  'townhome_3level': {
    crew2: [5.0, 6.0],
    crew3: [3.3, 4.0],
    crew4: [2.5, 3.0]
  }
};

// Complexity Multipliers
const FINISH_LEVEL_MULTIPLIERS = {
  standard: 1.0,
  high_end: 1.15,
  luxury: 1.25
};

const MESS_LEVEL_MULTIPLIERS = {
  clean: 0.9,
  normal: 1.0,
  messy: 1.2
};

export function calculateEstimate(formData) {
  const {
    unit_type = '2b_2b',
    num_units = 1,
    avg_unit_sqft = 1000,
    visits_initial = true,
    visits_final = true,
    complexity_finish_level = 'standard',
    complexity_mess_level = 'normal',
    crew_size_suggested = 4,
    hourly_wage = 20,
    burden_factor = 1.25,
    markup_factor = 1.4
  } = formData;

  // Get unit type data
  const unitData = UNIT_TYPES[unit_type] || UNIT_TYPES['2b_2b'];
  const labourHoursPerUnit = (unitData.labourHoursMin + unitData.labourHoursMax) / 2;

  // Calculate visit multiplier
  let visitMultiplier = 0;
  if (visits_initial) visitMultiplier += 0.5;
  if (visits_final) visitMultiplier += 0.5;
  if (visitMultiplier === 0) visitMultiplier = 1; // At least 1 visit

  // Calculate complexity multiplier
  const finishMultiplier = FINISH_LEVEL_MULTIPLIERS[complexity_finish_level] || 1.0;
  const messMultiplier = MESS_LEVEL_MULTIPLIERS[complexity_mess_level] || 1.0;
  const complexityMultiplier = finishMultiplier * messMultiplier;

  // Total hours
  const totalHours = labourHoursPerUnit * num_units * visitMultiplier * complexityMultiplier;

  // Days needed (assuming 6 productive hours per cleaner per day)
  const productiveHoursPerDay = 6;
  const daysNeeded = Math.ceil(totalHours / (crew_size_suggested * productiveHoursPerDay));

  // Labour cost
  const labourCost = totalHours * hourly_wage * burden_factor;

  // Quote price
  const quotePrice = labourCost * markup_factor;

  // Per-unit pricing
  const pricePerUnit = quotePrice / num_units;
  const totalSqft = num_units * avg_unit_sqft;
  const pricePerSqft = quotePrice / totalSqft;

  return {
    totalHours: Math.round(totalHours * 10) / 10,
    daysNeeded,
    labourCost: Math.round(labourCost * 100) / 100,
    quotePrice: Math.round(quotePrice * 100) / 100,
    pricePerUnit: Math.round(pricePerUnit * 100) / 100,
    pricePerSqft: Math.round(pricePerSqft * 100) / 100,
    complexityMultiplier: Math.round(complexityMultiplier * 100) / 100,
    labourHoursRange: `${unitData.labourHoursMin}-${unitData.labourHoursMax}`,
    unitTypeLabel: unitData.label,
    totalSqft
  };
}
